module.exports = {"350524100":"凤城镇","350524101":"蓬莱镇","350524102":"湖头镇","350524103":"官桥镇","350524104":"剑斗镇","350524105":"城厢镇","350524106":"金谷镇","350524107":"龙门镇","350524108":"虎邱镇","350524109":"芦田镇","350524110":"感德镇","350524111":"魁斗镇","350524112":"西坪镇","350524200":"参内乡","350524201":"白濑乡","350524202":"湖上乡","350524203":"尚卿乡","350524204":"大坪乡","350524205":"龙涓乡","350524206":"长坑乡","350524207":"蓝田乡","350524208":"祥华乡","350524209":"桃舟乡","350524210":"福田乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350524.json
// module id = 1106
// module chunks = 0